import { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";

export default function ContactForm() {
  const [formData, setFormData] = useState({ 
    name: "", 
    phone: "",
    email: "", 
    message: "" 
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const res = await fetch("https://mailerapi.vercel.app/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (res.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        setStatus(data.message || "Failed to send message");
      }
    } catch (err) {
      console.error(err);
      setStatus("Failed to send message");
    }
  };

  return (
    <Container className="my-2 contact-section">
      <Row className="justify-content-center">
        <Col xs={11} sm={8} md={6} lg={6}>
          <div className="p-2">            
            <Form onSubmit={handleSubmit}>
              {/* Full Name */}
              <Form.Group className="mb-2">
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full Name"
                  required
                  className="bg-transparent border-secondary"
                />
              </Form.Group>

              {/* Phone No */}
              <Form.Group className="mb-2">
                <Form.Control
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone No"
                  className="bg-transparent border-secondary"
                />
              </Form.Group>

              {/* Email */}
              <Form.Group className="mb-2">
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                  className="bg-transparent border-secondary"
                />
              </Form.Group>

              {/* Message */}
              <Form.Group className="mb-2">
                <Form.Control
                  as="textarea"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Message"
                  required
                  className="bg-transparent border-secondary"
                />
              </Form.Group>
              {/* Submit Button */}
              <div className="d-grid">
                <Button variant="primary" type="submit" size="lg">
                  Submit
                </Button>
              </div>
            </Form>

            {/* Status Message */}
          {status && (
            <Alert 
              className="mt-2 mb-0 bg-transparent border-0"
            >
              <span className={
                status.includes("successfully") ? "text-success fw-bold" :
                status === "Sending..." ? "text-info fw-bold" : "text-danger fw-bold"
              }>
                {status}
              </span>
            </Alert>
          )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}